<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >

      <div class="d-flex align-center">
        <v-img
          alt="FundEx"
          class="shrink mr-2"
          contain
          src="/static/logo.png"
          transition="scale-transition"
          width="80"
        />

      </div>

      <v-spacer></v-spacer>

    </v-app-bar>
    <Snackbar/>

    <v-main>
        <app-bar :menu-items="menuItems" />
        <UserTools />
        <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Snackbar from './components/Snackbar'
import { mapGetters } from 'vuex';
import UserTools from './components/UserTools'

export default {
  name: 'App',

  components: {
    Snackbar,
    UserTools
  },

  data: () => ({
    menu: [
        { title: 'Home', to: '/' },
        { title: 'Projects', to: '/Projects', loggedIn: true },
        { title: 'Portfolio', to: '/Portfolio', loggedIn: true },
    ]
  }),
  created: () => {
  },
  computed: {
      ...mapGetters([
        'loggedIn'
      ]),
      menuItems() {
        var self = this
        return self.menu.filter(m => !m.loggedIn || self.loggedIn)
      }
  }
};
</script>
